<template>
  <v-layout
    d-flex
    class="px-3 align-center"
  >
    <v-flex
      xs12
      sm4
    >
      {{ $t('Carrier') }}: {{ shipment.carrier }}
    </v-flex>
    <v-flex
      xs12
      sm4
    >
      {{ $t('Tracking ID') }}: {{ shipment.tracking_number }}
    </v-flex>
    <v-flex :class="$vuetify.rtl ? 'text-xs-left' : 'text-xs-right'">
      <v-list-tile-sub-title>{{ $t('Created at') }}: {{ shipment.created_at | timezone }}</v-list-tile-sub-title>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'OrderSingleShipmentCarrierDetails',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  }
}
</script>
